export const fetchInterlineOperatorsData = async () => {
  try {
      const headers = new Headers({
          "cache-control": "max-age=172800"
      })
    const response = await fetch('./content/ship/page-components/article/interline-operators.json', {
        headers: headers
    });
    const operators = await response.json();
    return operators;
  } catch (e) {
    console.log(e)
  }
};



// WEBPACK FOOTER //
// ./src/api/fetchInterlineOperatorsData.js